export const environment = {
  origin: '/prd/mybenk/mybenk_prd_environment.ts',
  envName: 'HML',
  production: true,
  firebase: {
    apiKey: "AIzaSyADtNj_n0IhXyxhAzqPp-tQChRoETwrdco",
    authDomain: "celcoin-prd.firebaseapp.com",
    projectId: "celcoin-prd",
    storageBucket: "celcoin-prd.appspot.com",
    messagingSenderId: "940968013662",
    appId: "1:940968013662:web:38c22caa5763bbbdcd69cf"
  },

  tenants: [
    {
      tenant: "celcoin-prd-94j6f",
      name: "mybenk",
      primaryColor: "#5749C2",
      overPrimary: "#000000",
      icon: "https://storage.googleapis.com/celcoin-prd.appspot.com/tenant-assets/Celcoin-prd/icon",
      apiKey: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJEaWxldHRhIFNvbHV0aW9ucyIsImlhdCI6MTcxMjE5NDA2OTM1NSwiYXVkIjoiY2VsY29pbi1wcmQiLCJzdWIiOiJDZWxjb2luIiwianRpIjoiMWQ4NmVhYjUtODc1Yi00MGQ4LWIyNGMtNDI3MGU0MDdlODExIiwidGVuYW50SWQiOiJjZWxjb2luLXByZC05NGo2ZiJ9.mJYCCjsA0ivlQw2ri9W3iOqQ_jtWW4gu84GOkZX6tNFTFKDNozk8pwS6pMBpXU09l2Qu9tndViICo8sP_hJ4kg",
      client: "matera",
      clientSuite: true,
      infoHeader: false,
      biz: false,
      apiUrl: 'https://api.mybenk.dilettapay.app',
      formattedName: "MyBenk",
      logo: "https://storage.googleapis.com/celcoin-prd.appspot.com/tenant-assets/Celcoin-prd/logo",
      logoLogin: "https://storage.googleapis.com/celcoin.appspot.com/tenant-assets/Celcoin-prd/logo-login",
      minimalLogin: false
    }
  ],
  apiUrl: 'https://api.mybenk.dilettapay.app',
  apiUrlFunctions: 'https://us-central1-celcoin-prd.cloudfunctions.net',
  keyEncryptAuth: 'oGTy7QtyHr48GE6re5KTckkGnbm6oo7SwRHsi2gqjapqflY9hjTAJ4GyUtt9YrSK',
  account: '413453',
  branch: '3100',
  wallet: '109',
  bank: '341',
  currency: '9'
}